export default __webpack_public_path__ + "static/alerts-a221671884933aa5903786c54efe7842.png";